import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { MainTaskSkeletonComponent } from './main-task-skeleton.component';

@NgModule({
  declarations: [
    MainTaskSkeletonComponent
  ],
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
    MainTaskSkeletonComponent
  ]
})
export class MainTaskSkeletonModule { }
